import { ContentContainer } from "components";
import ModalComponent from "components/Modal/ModalComponent";
import React, { useState } from "react";
import InformationsPayment from "./FieldsForm/informationPayment";
import PaymentList from "./List/paymentList";

const AccountPayments = () => {
	const [open, setOpen] = useState(false);
	const tableRef = React.useRef(null);
	const [modalProps, setModalProps] = useState({
		title: "",
		subtitle: "",
		onClick: () => { },
		buttonText: "",
		children: <></>
	});

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	return (
		<ContentContainer>
			<ModalComponent
				open={open}
				onClose={handleClose}
				{...modalProps}
			/>
			<InformationsPayment tableRef={tableRef} />
			<PaymentList setModalProps={setModalProps} handleOpen={handleOpen} handleClose={handleClose} tableRef={tableRef} />
		</ContentContainer>
	);
};

export default AccountPayments;
